// src/utils/adminApi.js
import axios from "axios";

const BASE_URL = "https://alkebulanfkalertbackend.onrender.com/api/admin";

// 🔑 Admin login only
const AdminAuthAPI = axios.create({
  baseURL: `${BASE_URL}/auth`,
  headers: { "Content-Type": "application/json" },
});

// 🛡️ Admin actions (users, verify, etc.)
const AdminAPI = axios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "application/json" },
});

// ✅ Attach admin token
AdminAPI.interceptors.request.use(
  (req) => {
    const token = localStorage.getItem("adminToken");
    if (token) {
      req.headers.Authorization = `Bearer ${token}`;
    }
    return req;
  },
  (error) => Promise.reject(error)
);

// ✅ Default + named exports
export default AdminAPI;        // 👈 FIX: Default export
export { AdminAuthAPI, AdminAPI };
